export default "__VITE_ASSET___nx0cxxV__"